import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { SharedFeaturesModule } from '@shared-features/shared-features.module';
import { SharedModule } from '@shared/shared.module';
import { FilterModule } from '@features/filter/filter.module';
import { NotificationsModule } from '@features/notifications/notifications.module';
import { PublicLayoutPage } from './pages/public-layout/public-layout.page';
import { SearchComponent } from './components/search/search.component';
import { PreCreateShipmentDialogComponent } from '@layout/components/sidenav/pre-create-shipment-dialog.component';
import i18n from './i18n';
import { LanguageService } from '@core/services';
import { RouterModule } from '@angular/router';
import { BidChatModule } from '@features/bid-chat/bid-chat.module';

@NgModule({
  declarations: [
    HeaderComponent,
    SidenavComponent,
    MainPageComponent,
    PublicLayoutPage,
    SearchComponent,
    PreCreateShipmentDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    SharedFeaturesModule,
    FilterModule,
    NotificationsModule,
    BidChatModule,
  ],
  exports: [MainPageComponent],
})
export class LayoutModule {
  constructor(private languageService: LanguageService) {
    languageService.registerModule(i18n);
  }
}
